import { Dialog, Fade, Typography } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { DialogProps } from '@material-ui/core/Dialog';
import React, { forwardRef, useCallback } from 'react';
import Scanner from 'views/pages/private/movimentacao/mov-prod-leitor/components/scanner/scanner';
import { useStyles } from './dialog-barcode-cam-styles';
import CloseIcon from '@material-ui/icons/Close';
import { useCadastros } from 'services/app';
import { useEventTools } from 'services/app/hooks/events/event-tools';
import { AppEventEnum } from 'model/enums/enum-app-event';
import { isEmpty } from 'lodash';

interface DialogBarCodeProps {
  openned?: boolean;
  loading?: boolean;
  zIndex?: string;
  tamanho?: DialogProps['maxWidth'];
  salao?: string
}

export const DialogBarCodeCam = ({
  ...props
}: DialogBarCodeProps) => {
  const classes = useStyles();
  const { fecharCadastroBarCodeCam } = useCadastros()
  const { callEvent } = useEventTools()

  const Transition = forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
  ) {
    return <Fade timeout={500} ref={ref} {...props} />;
  });

  const leituraRealizada = useCallback(
    (novoCod: string) => {
      callEvent(AppEventEnum.SetValueCam, props.salao && !isEmpty(props.salao) ? `${novoCod}|${props.salao}` : novoCod);
      fecharCadastroBarCodeCam();
    },
    [callEvent, fecharCadastroBarCodeCam, props.salao],
  );

  return (
    <>
      {props.openned &&
        <Dialog
          maxWidth={props.tamanho || 'md'}
          open={props.openned || false}
          fullWidth
          keepMounted
          className={classes.root}
          disableEscapeKeyDown
          TransitionComponent={Transition}
          ref={(el: any) => {
            if (el && (props.zIndex || '').length > 0) {
              el.style.setProperty('z-index', props.zIndex, 'important');
            }
          }}
        >
          <div style={{ padding: 8 }}>
            <Typography
              style={{
                textAlign: 'center',
                margin: '0 0 24px 0',
                fontWeight: '600',
                background: 'rgb(0 0 0 / 50%)',
                padding: 12,
                color: '#FFF',
                borderRadius: 8,
              }}
            >
              Posicione o código de barras na marcação
            </Typography>
            <div style={{ borderRadius: 8, overflowY: 'auto' }}>
              {props.openned && (
                <Scanner onScan={leituraRealizada} inicialOrSecundario={false} />
              )}
            </div>
            <div style={{ justifyContent: 'center', display: 'flex' }}>
              <CloseIcon
                onClick={() => {
                  fecharCadastroBarCodeCam();
                }}
                style={{ fontSize: 50, marginTop: 16, cursor: 'pointer' }}
              />
            </div>
          </div>
        </Dialog>
      }
    </>
  );
};
